<template>
  <div>
    <div style="text-align: right;z-index: 2;">
      <el-button size="small" style="text-align: right;" v-if="($store.state.Login.Department == 'IPQC' || $store.state.Login.Jurisdiction == 0)"  type="warning" @click="DekERPwlandget()">{{$t('All.重新获取ERP物料')}}</el-button>
      <el-button size="small" style="text-align: right;" v-if="($store.state.Login.Department == 'IPQC' || $store.state.Login.Jurisdiction == 0)"  type="primary" @click="TabComponent = 'LQrcode'">{{$t('All.扫描物料')}}</el-button>
    </div>
    <div class="zhadminadd" id="printTest">
    <h2 style="text-align: center;">{{this.$t('system.company')}}</h2>
    <h3 style="text-align: center;">{{$t('All.生产使用物料')}}</h3>
    <h4 style="text-align: center;">{{ $store.state.Gongdan }}</h4>
    <div style=" padding: 10px; text-align: center;">
      <div style="text-align: center;">
      <h3 style="text-align: center;">{{$t('All.ERP物料与生产使用物料对比')}}</h3>
      <el-table
        :data="getMergedList()"
        :row-class-name="erpRowClassName"
        style="width: 100%;padding: 10px; text-align: center;">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.material">
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column prop="IQCNumbers" width="50" align="center" label="报告">
                <template slot-scope="scopes">
                  <i v-if="scopes.row.IQCNumbers && scopes.row.IQCNumbers.length > 0" @click="openfunurl(scopes.row.IQCNumbers)" class="el-icon-s-order" style="text-align: center;font-size: 20px;"></i>
                </template>
              </el-table-column>
              <el-table-column prop="Supplier" sortable :label="$t('All.供应商')"> </el-table-column>
              <el-table-column prop="Feeding_date" sortable label="进料日期"> </el-table-column>
              <el-table-column prop="Person" sortable label="负责人"> </el-table-column>
              <el-table-column prop="Quantity" sortable :label="$t('All.数量')" width="80"> </el-table-column>
              <el-table-column prop="Unit" :label="$t('All.单位')"> </el-table-column>
              <el-table-column prop="Lot_no" label="LOT NO"> </el-table-column>
              <el-table-column prop="Username" sortable label="扫描者"> </el-table-column>
              <el-table-column :label="$t('All.操作')" width="150">
                <template slot-scope="opScope">
                  <el-button v-if="canDeleteMaterial(opScope.row)" @click="Delwuliao(opScope.row)" type="danger" size="mini">{{$t('All.删除')}}</el-button>
                  <el-button v-if="canReturnMaterial(opScope.row)" @click="Tuiliao(opScope.row)" type="warning" size="mini">{{$t('All.退料')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="Wmcpil" width="180" :label="$t('All.料号')" align="left" class-name="ellipsis-cell" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Wmdsc1" :label="$t('All.品名')" align="center" class-name="ellipsis-cell" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="Wmdsc2" :label="$t('All.规格')" align="center" class-name="ellipsis-cell" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="Wmuorg" label="标准量" align="center">
          <template slot-scope="scope">
            <span :class="{ 'empty-zero': isMissingNumber(scope.row.Wmuorg, 4) }">
              {{ displayNumberWithZero(scope.row.Wmuorg, 4) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="Wmtrqt" label="已发量" align="center">
          <template slot-scope="scope">
            <span :class="{ 'empty-zero': isMissingNumber(scope.row.Wmtrqt, 4) }">
              {{ displayNumberWithZero(scope.row.Wmtrqt, 4) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="Sjshiyongl" label="实际使用量" align="center">
          <template slot-scope="scope">
            <span :class="{ 'empty-zero': isMissingActualUsage(scope.row) }">
              {{ displayActualUsageWithZero(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="Wmum" :label="$t('All.单位')" align="center">
        </el-table-column>
      </el-table>
    </div>
    </div>
  </div>
  <transition name="fade-transform" mode="out-in">
        <component :is="TabComponent" :Iscoder="Iscoder" :Getxwuliao="Getxwuliao" :Materialadddata="Materialadddata" :gongdan="$store.state.Gongdan" :MaterialData="MaterialData" :GetMaterial="GetMaterial" style="z-index: 888;"></component>
    </transition>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      Material: [{
        Numbers: '',
        Index: 0,
        Quantity: '',
        IQCNumbers: '',
        Material_name: '',
        Supplier: '',
        Feeding_date: '',
        Person: '',
        Lot_no: '',
        Name: '',
        Serialcode: ''
      }],
      TabComponent: '',
      MaterialData: {},
      ERPMaterial: [],
      isendbool: false
    }
  },
  props: ['Addtab', 'RemoveTab', 'Renewtargename', 'Rendw'],
  components: {
    LQrcode: () => import('./LQrcode'),
    Tuliao: () => import('./Tuliao')
  },
  computed: {
    mergedList () {
      if (!this.ERPMaterial) return []
      const buckets = this.buildErpMaterialBuckets()
      const merged = this.ERPMaterial.map((r, idx) => {
        const materials = buckets[idx] || []
        return Object.assign({}, r, { material: materials, scanned: materials.length > 0, __order: idx })
      })
      return merged
        .sort((a, b) => {
          const sa = a.scanned ? 1 : 0
          const sb = b.scanned ? 1 : 0
          if (sa !== sb) return sa - sb
          return a.__order - b.__order
        })
        .map(({ __order, ...row }) => row)
    }
  },
  async created () {
    await this.GetMaterial(this.$store.state.Gongdan)
    this.GetEndwuliao(this.$store.state.Gongdan)
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['FQCNumerb']),
    Iscoder (row) {
      this.TabComponent = row
    },
    handleClose (done) {
      this.$confirm(this.$t('All.确认关闭'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    getCurrentTime () {
      // 获取当前时间并打印
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const gettime = yy + '-' + mm + '-' + dd
      return gettime
    },
    Tuiliao (row) {
      this.MaterialData = row
      this.TabComponent = 'Tuliao'
    },
    Delwuliao (row) {
      this.$confirm(this.$t('All.是否删除此节点'), this.$t('All.提示'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(() => {
          this.removeMaterial(row)
        })
        .catch(() => {
        })
    },
    Materialaddlist (item, index) {
      const contr = {
        Numbers: item.Numbers,
        Index: item.Index + 1,
        Quantity: '',
        IQCNumbers: '',
        Material_name: '',
        Supplier: '',
        Feeding_date: '',
        Person: '',
        Lot_no: '',
        Name: '',
        Serialcode: ''
      }
      this.Material.splice(index + 1, 0, contr)
      for (let i = 0; i < this.Material.length; i++) {
        this.Material[i].Index = i
      }
    },
    async removeMaterial (item) {
      const { data: res } = await this.$http.post('/api/Semifinished/DelMaterial', item)
      if (res.status !== 200) return this.$message.error(res.msg)
      var index = this.Material.indexOf(item)
      if (index !== -1) {
        this.Material = this.Material.filter(x => x.Serialcode !== item.Serialcode)
      }
      for (let i = 0; i < this.Material.length; i++) {
        this.Material[i].Index = i
      }
      this.updateScannedFlags()
    },
    Getxwuliao (row) {
      for (let j = 0; j < this.Material.length; j++) {
        if (this.Material[j].Serialcode === row) {
          this.$message.error(this.$t('All.此PASS数据已被采集'), this.$t('All.请勿重复扫描'))
          return true
        }
      }
      return false
    },
    Materialadddata (row) {
      /* for (let j = 0; j < this.Material.length; j++) {
        if (this.Material[j].Serialcode === row.Serialcode) {
          this.$message.error('此PASS数据已被采集，请勿重复扫描！')
          return 'NO'
        }
      }
      var res = this.$http.post('/api/Semifinished/AddMaterial', row)
      console.log(res)
      if (res.status !== 200) return this.$message.error(res.msg)
      row.Index = this.Material.length
      this.Material.push(row)
      this.$message.success('采集成功！')
      return 'OK' */
      for (let j = 0; j < this.Material.length; j++) {
        if (this.Material[j].Serialcode === row.Serialcode) {
          this.$message.error(this.$t('All.此PASS数据已被采集'), this.$t('All.请勿重复扫描'))
          return
        }
      }

      // 发起异步请求
      this.$http.post('/api/Semifinished/AddMaterial', row)
        .then((response) => {
          // 检查HTTP响应状态码
          if (response.status === 200) {
            const res = response.data

            // 处理服务器端返回的数据
            if (res.status === 200) {
              row.Index = this.Material.length
              this.Material.push(row)
              this.$message.success(this.$t('All.采集成功'))
              this.updateScannedFlags()
            } else {
              this.$message.error(res.msg)
            }
          } else {
            this.$message.error(this.$t('All.HTTP请求失败'))
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message.error(this.$t('All.操作失败'))
        })
    },
    async GetMaterial (row) {
      const { data: res } = await this.$http.get(`/api/Semifinished/GetMaterial?gongdan=${row}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.Material = res.response
    },
    async GetEndwuliao (row) {
      const { data: res } = await this.$http.get(`/api/Semifinished/GetEndwuliao?gongdan=${row}`)
      if (res.status !== 200) return this.$message.error(res.msg)
      this.ERPMaterial = res.response
      this.updateScannedFlags()
    },
    buildErpMaterialBuckets () {
      const erpList = this.ERPMaterial || []
      const materialList = this.Material || []
      const buckets = erpList.map(() => [])
      if (erpList.length === 0 || materialList.length === 0) return buckets

      const norm = v => (v === undefined || v === null) ? '' : String(v).trim().toUpperCase()
      const pushMap = (map, key, value) => {
        if (!key) return
        const arr = map.get(key)
        if (arr) {
          arr.push(value)
          return
        }
        map.set(key, [value])
      }
      const pickIndex = (map, cursorMap, key) => {
        if (!key) return -1
        const arr = map.get(key)
        if (!arr || arr.length === 0) return -1
        const cursor = cursorMap.get(key) || 0
        const selected = arr[cursor % arr.length]
        cursorMap.set(key, cursor + 1)
        return selected
      }

      const itemMap = new Map()
      const nameMap = new Map()
      for (let i = 0; i < erpList.length; i++) {
        pushMap(itemMap, norm(erpList[i].Wmcpil), i)
        pushMap(nameMap, norm(erpList[i].Wmdsc1), i)
      }

      const itemCursor = new Map()
      const nameCursor = new Map()
      const usedMaterialKeys = new Set()

      for (let i = 0; i < materialList.length; i++) {
        const material = materialList[i]
        const materialKey = material && material.Serialcode ? `S:${material.Serialcode}` : `I:${i}`
        if (usedMaterialKeys.has(materialKey)) continue

        const mItem = norm(material && material.Item_no)
        const mName = norm(material && material.Material_name)
        let targetIndex = pickIndex(itemMap, itemCursor, mItem)
        if (targetIndex === -1) {
          targetIndex = pickIndex(nameMap, nameCursor, mName)
        }
        if (targetIndex === -1) continue

        buckets[targetIndex].push(material)
        usedMaterialKeys.add(materialKey)
      }

      return buckets
    },
    updateScannedFlags () {
      if (!this.ERPMaterial || !this.Material) return
      const buckets = this.buildErpMaterialBuckets()
      for (let i = 0; i < this.ERPMaterial.length; i++) {
        const r = this.ERPMaterial[i]
        this.$set(r, 'scanned', (buckets[i] || []).length > 0)
      }
    },
    getMaterialState (row) {
      if (!row) return null
      const raw = row.State !== undefined ? row.State : row.state
      if (raw === undefined || raw === null || raw === '') return null
      const num = Number(raw)
      if (!isNaN(num)) return num
      return String(raw).trim()
    },
    isEditableState (row) {
      const state = this.getMaterialState(row)
      // 兼容后端返回 number/string/bool/空值：未明确锁定或完成都允许操作
      if (state === null || state === undefined || state === '') return true
      if (state === 0 || state === '0' || state === false || state === 'false') return true
      if (state === 1 || state === '1' || state === true || state === 'true') return false
      const normalized = String(state).trim().toLowerCase()
      if (normalized === 'lock' || normalized === 'locked' || normalized === 'done' || normalized === 'end' || normalized === 'closed') return false
      return true
    },
    canDeleteMaterial (row) {
      const login = (this.$store && this.$store.state && this.$store.state.Login) || {}
      return row && Number(row.State) === 0 && (login.Department === 'IPQC' || Number(login.Jurisdiction) === 0)
    },
    canReturnMaterial (row) {
      const login = (this.$store && this.$store.state && this.$store.state.Login) || {}
      return row && Number(row.State) === 0 && (Number(login.Jurisdiction) === 9 || Number(login.Jurisdiction) === 0)
    },
    erpRowClassName ({ row }) {
      if (this.isNoDataRow(row)) return 'empty-row'
      return row && row.scanned ? 'scanned-row' : ''
    },
    getMergedList () {
      return this.mergedList || []
    },
    openfunurl (url) {
      window.open('#/vnewiqc/' + url)
    },
    // 格式化数字并去掉无意义的尾部 0（默认保留最多4位小数）
    formatNumberTrim (val, decimals = 4) {
      if (val === null || val === undefined || val === '') return ''
      const n = Number(val)
      if (isNaN(n)) return ''
      const fixed = n.toFixed(decimals)
      return Number(fixed).toString()
    },
    displayNumberWithZero (val, decimals = 4) {
      const text = this.formatNumberTrim(val, decimals)
      return text === '' ? '0' : text
    },
    isMissingNumber (val, decimals = 4) {
      return this.formatNumberTrim(val, decimals) === ''
    },
    displayActualUsageWithZero (row) {
      const text = this.getActualUsage(row)
      return text === '' ? '0' : text
    },
    isMissingActualUsage (row) {
      return this.getActualUsage(row) === ''
    },
    isNoDataRow (row) {
      if (!row) return true
      return this.isMissingActualUsage(row)
    },
    getActualUsage (row) {
      if (!row) return ''
      // 如果 ERP 行已有 Sjshiyongl，则按 ERPDATA 显示规则优先使用
      if (row.Sjshiyongl !== undefined && row.Sjshiyongl !== null && row.Sjshiyongl !== '') {
        let v = Number(row.Sjshiyongl)
        if (isNaN(v)) return ''
        if (row.Wmum === 'GM') v = v * 1000
        return this.formatNumberTrim(v, 4)
      }
      // 否则累加展开行中的扫描记录数量字段（Quantity）
      const mats = row.material || []
      const nums = mats.map(m => {
        const n = Number(m.Quantity)
        if (isNaN(n)) return null
        return row.Wmum === 'GM' ? n * 1000 : n
      }).filter(v => v !== null)
      if (nums.length === 0) return ''
      const total = nums.reduce((a, b) => a + b, 0)
      return this.formatNumberTrim(total, 4)
    },
    async DekERPwlandget () {
      this.$confirm(this.$t('All.请勿多次操作确认要重新获取ERP资料吗'), this.$t('All.提示'), {
        confirmButtonText: this.$t('All.确认'),
        cancelButtonText: this.$t('All.取消'),
        type: 'warning'
      })
        .then(async () => {
          const loadingInstance2 = this.$loading({ text: this.$t('All.获取数据中请稍等'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.8)' })
          const { data: res } = await this.$http.post(`/api/Semifinished/DekERPwlandget?gongdan=${this.$store.state.Gongdan}`)
          if (res.status !== 200) {
            loadingInstance2.close()
            return this.$message.error(res.msg)
          }
          loadingInstance2.close()
          this.$message.success(res.msg)
        })
        .catch(() => {
        })
    }
  }
}
</script>
<style lang="less" scoped>
  .wbobye{
  left:0;
  right:0;
  top:0;
  bottom:0;
  margin:auto;
  position: fixed;
  height: 100%;
  background-color: rgba(255, 255, 255);
  min-width: 903px;
  width: 100%;
}
  .el-col {
    border: 1px solid;
    margin-right: -1px;
     margin-bottom: -1px;
    line-height: 4.5vw;
    font-size: 2vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }
  .grid-content {
    min-height: 36px;
  }
  .bg-purple-light{

  }
  .row-bg {
    background-color: #f9fafc;
  }
  .scanned-row {
    background-color: #f0fff0 !important;
  }
  ::v-deep .el-table .empty-row > td {
    color: #f56c6c !important;
    background-color: #fff0f0 !important;
  }
  .empty-zero {
    color: #f56c6c;
    font-weight: 600;
  }
table .td{
  border: none;
}
</style>
